import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  padding-bottom: ${size[24]};
  display: flex;
  justify-content: center;
  background-color: ${theme.palette.primary.mainContrast};
  color: ${theme.palette.background.main};
`

export const light = (theme: Theme) => css`
  background-color: ${theme.palette.background.main};
  color: ${theme.palette.text.title};
  padding: 0;

  ${breakpoint.up('smMd')} {
    background: linear-gradient(
      to right,
      ${theme.palette.background.accent} 50%,
      ${theme.palette.secondary.mainContrast} 50%
    );
  }
`

export const content = css`
  ${breakpoint.up('smMd')} {
    max-width: ${width.container.large};
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
`

export const text = css`
  padding: 0 ${size[24]} ${size[24]};
`

export const textLight = css`
  max-width: ${width.container.standard};
  margin: 0 auto;
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  max-width: ${width.modal.compact};
  margin-top: ${size[24]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const description = css`
  margin-top: ${size[24]};
  font-size: ${fontSize.md};
  line-height: ${size[24]};

  ${breakpoint.up('smMd')} {
    margin-top: ${size[40]};
  }
`

export const qrCode = (theme: Theme) => css`
  padding: ${size[16]};
  display: flex;
  align-items: center;
  gap: ${size[16]};

  background-color: ${theme.palette.background.main};
  color: ${theme.palette.primary.mainContrast};
  border-radius: ${size[8]};
  box-shadow: 0px 9.6px 39.2px 0px #1d06281a;

  p {
    font-size: 22px;
  }

  ${breakpoint.up('smMd')} {
    max-width: 275px;
  }
`

export const stores = css`
  margin: ${size[16]} 0 ${size[24]};
  display: flex;
  gap: ${size[12]};
`

export const inlineStores = css`
  margin-top: ${size[16]};
  display: flex;
  gap: ${size[12]};
`

export const cta = css`
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  margin-top: ${size[24]};

  a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    gap: ${size[24]};
  }
`

export const image = (theme: Theme) => css`
  background-color: ${theme.palette.secondary.mainContrast};
`
